export const GET_ALL_BANNERS = 'GET_ALL_BANNERS';
export const GET_ALL_SLIDERS = 'GET_ALL_SLIDERS';
export const GET_ALL_COUPONS = "GET_ALL_COUPONS";
export const GET_ALL_SCRATCH_CARDS = "GET_ALL_SCRATCH_CARDS";
export const GET_ALL_SCRATCH_CARD_WINNERS = "GET_ALL_SCRATCH_CARD_WINNERS";
